export enum AdminQuestionsTableColumnTitle {
  OrdinalNumber = "Redni broj",
  Question = "Pitanje",
  Options = "",
}
